<template></template>

<script>
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'GeneralReport',
    components: {},
    methods: {
      initFlatpickr() {
        $('#startDate').flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
          maxDate: new Date(),
        })

        $('#endDate').flatpickr({
          disableMobile: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
          maxDate: new Date(),
        })
      },
    },
    mounted () {
      const vm = this

      $(() => {
        /**
         * Init Flatpickr
         */
        vm.initFlatpickr()

        window.livewire.on('submit', () => {
          vm.initFlatpickr()
        })
      })
    },
  }
</script>
